export default `float i,g,e,R,S;vec3 q;
    q=p*2.;
    R=7.;
    for(int j=0;j++<9;){
      p=-sign(p)*(abs(abs(abs(p)-2.)-1.)-1.);
      S=-9.*clamp(.7/min(dot(p,p),3.),0.,1.);
      p=p*S+q; R=R*abs(S);
    }
    return length(p)/R;
  }`